import { ECategory } from '../../../types/share';
import { NBSP } from '../../../constants/symbols';

export function getPriceDescription(category: ECategory) {
  switch (category) {
    /** Аренда */
    case ECategory.CommercialRent:
    case ECategory.SuburbanRent:
      return `Ставка рассчитана по объявлениям объектов, которые в данный момент сдаются на${NBSP}Циан. За${NBSP}100% принята средняя цена в${NBSP}январе${NBSP}2020`;
    case ECategory.DailyFlatRent:
    case ECategory.FlatRent:
      return `Ставка рассчитана по объявлениям однокомнатных квартир, которые в данный момент сдаются на${NBSP}Циан. За${NBSP}100% принята средняя цена в${NBSP}январе${NBSP}2020`;

    /** Продажа */
    case ECategory.NewBuildingFlatSale:
    case ECategory.CommercialSale:
    case ECategory.FlatSale:
      return `Цена рассчитана по объявлениям квартир, которые в данный момент находятся в продаже. За${NBSP}100% принята средняя цена в${NBSP}январе${NBSP}2020`;
    case ECategory.SuburbanSale:
      return `Цена рассчитана по объявлениям объектов, которые в данный момент находятся в продаже. За${NBSP}100% принята средняя цена в${NBSP}январе${NBSP}2020`;
  }
}
